import HeroBg from "public/kubernetes/hero-section-background.png";

export const HERO_CONSTANTS = {
  desc: "Deploy production-grade, CNCF-compliant Kubernetes clusters without operational complexity. Get built-in RBAC, auto-scaling, and public cluster support—all fully managed by OneMind on Taikun. ",
  title: "Managed Kubernetes, Simplified.",
  image: HeroBg,
  button: {
    label: "Check our plans",
    link: "kubernetes",
  },
  button2: {
    label: "Launch Your K8s Cluster Today ",
    link: "contact-us",
  },
};
